<template>
  <div class="container-lg">
    <div>
      <div :class="s.title">
        <p class="fs-3 fw-bold mb-4">
          <i class="fa-solid fa-tablet-screen-button" />
          注文デバイス管理
        </p>
      </div>
      <div class="row">
        <div class="col-9">
          <AdminItemList
            :items="tablets"
            :is-loading="flag.isLoading"
            :draggable="false"
            :edit-id="editId"
            :item-class="s.tablet"
            :edit-class="s.edit"
            empty-message="※デバイスが登録されていません。新規登録してください。"
            @start-edit="startEdit">
            <template #item-display="{ item, isEditing }">
              <div
                v-if="!isEditing"
                class="d-flex align-items-center justify-content-between">
                <div>
                  <span>
                    {{ item.label || '名前未設定' }}
                  </span>
                  <span class="d-inline opacity-50">{{ item.name || '商品名未設定' }}</span>
                  <span
                    v-if="item.id == getDiningTableID()"
                    class="badge bg-danger ms-2">
                    登録済み
                  </span>
                  <span class="d-block small opacity-50">識別ID:{{ item.device_uuid }}</span>
                </div>
                <div>
                  <button
                    @click="printQrCode(item)"
                    class="btn btn-outline-primary btn-sm me-2">QRコード</button>
                  <button
                    @click="startEdit(item)"
                    class="btn btn-outline-success btn-sm">編集・再登録</button>
                </div>
              </div>
            </template>
            <template #item-edit="{ isEditing }">
              <div
                :class="s.form"
                v-if="isEditing">
                <div>
                  <label for="">ステータス</label>
                  <select
                    class="form-control form-control-sm"
                    name="flag"
                    id="flag"
                    v-model="updateData.flag">
                    <option
                    v-for="(flag) of saleFlag"
                    :key="flag.label"
                    :value="flag.value">{{ flag.label }}</option>
                  </select>
                </div>
                <div class="mt-3">
                  <label for="">注文卓名</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="updateData.label">
                </div>
                <div class="mt-3">
                  <label for="">注文卓名(管理)</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="updateData.name">
                </div>
                <div class="d-flex mt-3">
                  <button
                    class="btn btn-primary btn-sm"
                    :disabled="!updateData.flag ||!updateData.label ||!updateData.name"
                    @click="regist">更新</button>
                  <button
                    @click="cancelEdit()"
                    class="btn btn-outline-danger btn-sm ms-2">キャンセル</button>
                </div>
              </div>
            </template>
          </AdminItemList>
        </div>
        <div class="col-3 cards">
          <AdminSearchCard
            :keyword="searchParams.keyword"
            :flag="searchParams.flag"
            @update:keyword="searchParams.keyword = $event"
            @update:flag="searchParams.flag = $event"
            :flag-options="saleFlag"
            :form-class="s.form"
            keyword-placeholder="注文卓名を入力" />
          <AdminCreateCard
            :disabled="!label || !name"
            :form-class="s.form"
            @submit="regist">
            <template #fields>
              <div class="mt-3 text-start">
                <label for="email" class="ms-1">注文卓名</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="label"
                  :disabled="editId"
                  placeholder="1番卓">
              </div>
              <div class="mt-3 text-start">
                <label for="email" class="ms-1">注文卓名(管理)</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="name"
                  :disabled="editId"
                  placeholder="first">
              </div>
            </template>
          </AdminCreateCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AdminItemList from '@/components/admin/AdminItemList.vue';
import AdminSearchCard from '@/components/admin/AdminSearchCard.vue';
import AdminCreateCard from '@/components/admin/AdminCreateCard.vue';

export default {
  name: 'admin-tablet',
  components: {
    AdminItemList,
    AdminSearchCard,
    AdminCreateCard,
  },
  data() {
    return {
      flag: {
        isLoading: true,
        changeKeyword: false,
      },
      validationFlags: {
        mail: false,
      },
      invalids: {
        mail: true,
      },
      // 有効期限切れでリダイレクトされた
      tablets: [],
      searchParams: {
        flag: 1,
        keyword: null,
      },
      label: null,
      name: null,
      updateData: {
        flag: null,
        label: null,
        name: null,
        device_uuid: null,
      },
      saleFlag: [
        {
          name: 'flag',
          label: '利用可能',
          value: '1',
          hover: false,
        },
        {
          name: 'flag',
          label: '利用停止中',
          value: '0',
          hover: false,
        },
      ],
      editId: null,
      targetColumns: ['label', 'name'],
    };
  },
  created() {
    this.getTablets();
  },
  computed: {
    ...mapState(['user']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.mail;
    },
    getTabletOptions() {
      return this.tablets.map(type => ({
        id: type.id,
      }));
    },
  },
  watch: {
    tablet: {
      handler() {
        this.getTablets();
      },
      deep: true,
    },
    searchParams: {
      handler() {
        if (!this.editId) {
          this.getTablets();
        }
      },
      deep: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    printQrCode(item) {
      if (!item.device_uuid || !this.user.id) return;
      const targetUrl = `${window.location.origin}/?uuid=${item.device_uuid}&user_id=${this.user.id}`;
      const qrApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(targetUrl)}`; // サイズを少し大きめに
      const printWindow = window.open('', '_blank', 'width=600,height=600');
      printWindow.document.write(`
        <html>
          <head>
            <style>
              body {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100vh; /* 画面の高さいっぱい */
                margin: 0;
                font-family: sans-serif;
                padding: 10mm; /* 印刷時の余白を考慮 */
                box-sizing: border-box;
              }
              img {
                width: 100%; /* 幅を100%に */
                max-width: 100%; /* 念のためmax-widthも */
                height: auto;
                max-height: calc(100vh - 100px); /* 縦方向も大きく、ラベルのスペースを考慮 */
                object-fit: contain; /* アスペクト比を維持 */
              }
              .label {
                margin-top: 20px;
                font-size: 24px;
                font-weight: bold;
                text-align: center;
              }
              .sub-label { /* 新しいクラス */
                font-size: 16px;
                font-weight: normal;
                margin-top: 10px;
                text-align: center;
              }
              @media print {
                body {
                  height: auto; /* 印刷時は高さを自動に */
                  padding: 5mm;
                }
                img {
                  max-height: 90vh; /* 印刷時のQRコードをページいっぱいに */
                }
                .no-print { display: none; }
              }
            </style>
          </head>
          <body>
            <img src="${qrApiUrl}" alt="QR Code" onload="window.print();" />
          </body>
        </html>
      `);
      printWindow.document.close();
    },

    getTablets() {
      if (!this.user.id) return;
      this.flag.isLoading = true;

      const params = {
        user_id: this.user.id,
      };

      if (this.searchParams.flag) params.flags = [this.searchParams.flag];
      if (this.searchParams.keyword) {
        params.targetColumn = this.targetColumns;
        params.keyword = [this.searchParams.keyword];
      }

      this.axios({
        method: 'get',
        url: 'v1/diningtable/get/list',
        params,
      })
        .then((response) => {
          this.tablets = response.data.list.data;
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。');
        })
        .finally(() => {
          this.flag.isLoading = false;
        });
    },

    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    init() {
      this.editId = null;
      this.updateData.flag = null;
      this.updateData.label = null;
      this.updateData.name = null;
      this.updateData.device_uuid = null;
    },

    startEdit(tablet) {
      this.init();
      this.editId = tablet.id;
      this.updateData.flag = tablet.flag;
      this.updateData.label = tablet.label;
      this.updateData.name = tablet.name;
      this.updateData.device_uuid = tablet.device_uuid;
    },

    cancelEdit() {
      this.init();
    },

    createUUID() {
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.floor(Math.random() * 16);
        let v;
        if (c === 'x') {
          v = r;
        } else {
          v = (r && 0x3) || 0x8;
        }
        return v.toString(16);
      });
      return uuid;
    },

    /** サブミット */
    regist(e) {
      if (e) e.preventDefault();
      this.showLoading();

      this.flag.isLoading = true;

      const endpoint = this.editId ? 'update' : 'create';

      const data = {
        flag: this.updateData.flag || this.flag,
        label: this.updateData.label || this.label,
        name: this.updateData.name || this.name,
        user_id: this.user.id,
        device_uuid: localStorage.getItem('deviceUUID'),
      };

      if (endpoint === 'create') {
        data.flag = 1;
      }
      if (endpoint === 'update') {
        data.id = this.editId;
        if ((data.device_uuid !== this.updateData.device_uuid) && data.device_uuid) {
          alert('登録されたデバイス本体からログインして、更新してください。');
          this.flag.isLoading = false;
          this.getTablets();
          this.hideLoading();
          return;
        }
      }

      if (!data.device_uuid) {
        data.device_uuid = this.createUUID();
        localStorage.setItem('deviceUUID', data.device_uuid);
      }

      this.axios({
        method: 'POST',
        url: `/v1/diningtable/${endpoint}`,
        data,
      })
        .then((response) => {
          const res = response.data;
          if (endpoint === 'create' && res.exists) {
            alert('登録デバイスが重複しています。別デバイスでログイン後、再度登録してください。');
            if (!localStorage.getItem('diningTableID')) {
              localStorage.removeItem('deviceUUID');
            }
          } else if (endpoint === 'create') {
            alert('デバイスを登録しました。');
            localStorage.setItem('diningTableID', res.diningTableId);
            this.init();
          }
          if (endpoint === 'update') {
            alert('デバイス情報を更新しました。');
            localStorage.setItem('diningTableID', res.diningTableId);
            this.init();
          }
          console.log(res);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.getTablets();
          this.hideLoading();
          this.flag.isLoading = false;
        });
    },
    getDiningTableID() {
      const diningTableId = localStorage.getItem('diningTableID');
      return diningTableId ? parseInt(diningTableId, 10) : null;
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  display: flex;
  justify-content: center;
}

.title {
  text-align: center;
  color: rgba(152, 121, 89, 1);
}

.form {
  text-align: center;
}

.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #666;
  font-weight: bold;
  color: #fff;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
}
.form {
  label {
    color: var(--label-secondary);
    font-size: 14px;
    font-weight: 700;
  }
}
.item {
  transition: all .5s;
  max-height: 80px;
  overflow: hidden;
  &.edit {
    max-height: 1000px;
  }
}

.message {
  font-size: 12px;
  text-align: center;
}

.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  input {
    width: 100%;
    padding: 13px;
    border-radius: 8px;
    border: none;
    background-color: var(--gray-sub);
    outline: none;
  }
}
.comment {
  font-size: 12px;
  color: var(--red);
}
</style>
